import React, { useState } from 'react';
import OpenSeaDragon from 'openseadragon';
import { css } from '@mui/material';

interface Image {
    url: string;
    title?: string;
}

interface GalleryToolProps {
    viewer: OpenSeaDragon.Viewer | null;
    images: Image[];
    onImageChanged: () => void;
}

const containerStyle = css({
    display: 'flex',
    padding: 10,
    overflowX: 'auto',
    background: '#f4f4f4',
    borderRadius: 8,

    '& .item': {
        cursor: 'pointer',
        textAlign: 'center',
        minWidth: '120px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',

        '& .label': {
            fontWeight: 'bold' ,
            fontSize: '12px'
        }
    }
});

const thumbStyle: React.CSSProperties = {
    width: '100px',
    height: 'auto',
    borderRadius: '4px',
    border: '1px solid #ccc'
};

export const GalleryTool: React.FC<GalleryToolProps> = ({ viewer, images, onImageChanged }) => {
    const [selectedIndex, setSelectedIndex] = useState(0);

    const handleImageClick = (url: string, index: number) => {
        setSelectedIndex(index);
        if (viewer) {
            viewer.open({
                type: 'image',
                url: url,
            });
            onImageChanged();
        }
    };

    return (
        <div css={containerStyle}>
            {images.map((img, index) => (
                <div
                    className='item'
                    key={index}
                    onClick={() => handleImageClick(img.url, index)}
                >
                    {img.title && (
                        <p className='label' style={{ color: index === selectedIndex ? 'red':'black' }}>
                            {img.title}
                        </p>
                    )}
                    {/*<img
                        src={img.url}
                        alt={img.title || `Image ${index}`}
                        style={thumbStyle}
                    />*/}
                </div>
            ))}
        </div>
    );
};